const amphureReducer = (state = "", action) => {
    let { type, amphure } = action;
    switch (type) {
        case "ADD_AMPHURE":
            return amphure;
        default:
            return state;
    }
};

export default amphureReducer;
